// Este arquivo é gerado automaticamente no build
export const appVersion = '0.16.1';
export const buildDate = '2026-05-08T07:25:20.653Z';
export const buildNumber = '1778225120653';
export const environment = 'development';
